module.exports = __webpack_public_path__ + "assets/img/00164.c9252205.png";